import { OrganizationMetadata } from '@sonar-software/sonar-core';
import { useAuthToken } from '../useAuthToken';
import { useOrganizations } from './useOrganizations';

/**
 * Subscribes to the current organization the current user is set to.
 * May be undefined if the auth token does not have an `organizationId` set, or there is no matching
 * organization in the current state.
 * @returns An {@link OrganizationMetadata} instance, or undefined.
 */
export function useCurrentOrganization(): OrganizationMetadata | undefined {
	const { organizationId } = useAuthToken();
	const organizations = useOrganizations();

	if (!organizationId || !organizations.length) {
		return undefined;
	}

	return organizations.find((org) => org.id === organizationId);
}
